<template>
  <div>
    <div class="pagebanner">
      <h1
        style="padding-top:40px;padding-left:180px;color:black;float:left;font-size:300%;font-style: italic"
      >我们的愿景</h1>
      <h1
        style="padding-top:80px;padding-left:-80px;color:black;float:left;font-size:300%;font-style: italic"
      >——成为更长久更健康的企业</h1>
    </div>
    <br />
    <div style="background-color:rgba(242, 242, 242, 1);height:500px;">
      <div style="float:left;padding-left:10%;width:30%;display: inline-block">
        <div style="padding-top:70px;">
          <img src="../../assets/img/bg/who.jpg" />
        </div>
      </div>
      <div style="float:right;width:50%;padding-right:10%;display: inline-block;">
        <div style="padding-top:60px;">
          <p style="font-size:40px;text-align:left;padding-left:40px;">
            我们是谁
            <span style="font-style: italic;font-size:50%">/WHO WE ARE</span>
          </p>
        </div>
        <!-- <div style="background-color:#0075E9;margin-bottom:60px;height:300px;width:80%;color:white"> -->

        <h3
          style="font-size:21px;padding-top:50px;padding-left:40px;padding-right:40px;text-align:left;font-weight:400;"
        >东莞市腾盛软件科技有限公司是专注为用户提供安全、便捷服务的科技公司，主要团队位于深圳。在业务上主要依托OPPO、vivo、小天才丰富的移动端线上交易场景及亿级C端用户，聚焦于提供互联网科技支持和服务，助力于打造健康、高效的互联网科技生态。</h3>
      </div>
    </div>
    <br />

    <h3 style="text-align:left;margin-left:11%;font-size:300%;margin-bottom:10px;font-weight:400">
      企业文化
      <span style="font-size:50%;font-style:italic">/ COMPANY CULTURE</span>
    </h3>
    <el-card
      style="text-align:left;margin-left:10%;margin-right:10%;background-color: rgba(242, 242, 242, 1);"
    >
      <!-- <h1 style="opacity:0.3">TENSER</h1> -->
      <el-row>
        <div style="float:left;padding-left:13%">
          <h2 style="font-size:30px;font-weight:400">本分</h2>
          <p style="font-size:13px">保持求责于己的态度，坚持做正确的事</p>
        </div>
        <div style="float:right;padding-right:16%;">
          <h2 style="font-size:30px;font-weight:400">品质</h2>
          <p style="font-size:13px">保持求责于己的态度，坚持做正确的事</p>
        </div>
      </el-row>
      <br />
      <el-row>
        <div style="float:left;padding-left:13%">
          <h2 style="font-size:30px;font-weight:400">诚信</h2>
          <p style="font-size:13px">诚实无欺，敢于承认错误</p>
        </div>
        <div style="float:right;padding-right:16%;">
          <h2 style="font-size:30px;font-weight:400">学习</h2>
          <p style="font-size:13px;">我们是学习型的公司，我们必须永远保</p>
          <p style="font-size:13px;">持学习的动力和求知的欲望</p>
        </div>
      </el-row>
      <br />
      <el-row>
        <div style="float:left;padding-left:13%">
          <h2 style="font-size:30px;font-weight:400">团队</h2>
          <p style="font-size:13px">相互信任，坦诚沟通</p>
        </div>
        <div style="float:right;padding-right:16%;">
          <h2 style="font-size:30px;font-weight:400">创新</h2>
          <p style="font-size:13px">新思想＋能够带来改进或价值的行动&nbsp;&nbsp;&nbsp;&nbsp;</p>
        </div>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "AboutMe",
};
</script>

<style scoped>
.pagebanner {
  position: relative;
  color: #fff;
  overflow: hidden;
  height: 373px;
  background: url(../../assets/img/bg/head.jpg) no-repeat;
  background-size: 100% 100%;
  margin-bottom: 30px;
}

div img {
  width: 100%;
  /* height: 100%; */
  height: 360px;
  object-fit: cover;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/about/AboutMe.vue